module.exports = __webpack_public_path__ + "media/images/undraw/shift/profile-577d14ab93518556bc09155f7ed4062d.png";